import {
  ExpandableSection,
  TextContent,
} from "@cloudscape-design/components-themed";
import { formatLabel } from "../../utils/format";

interface IMerchantInfoExpandableSection {
  headerText: string;
  texts?: string[];
}

/**
 * 入金口座情報照会・更新 加盟店情報 展開表示
 */
export const MerchantInfoExpandableSection = (
  props: IMerchantInfoExpandableSection
) => {
  const { headerText, texts } = props;

  return (
    <ExpandableSection
      variant={"container"}
      headerText={formatLabel(headerText, [texts?.length ?? 0])}
    >
      <TextContent>
        <p>{texts?.join("、") ?? "　"}</p>
      </TextContent>
    </ExpandableSection>
  );
};
